var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(-112 -410)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(112 410)",
    fill: "#3dc5d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M4,13.179.172,9.355a.588.588,0,0,1,0-.832L1,7.691a.588.588,0,0,1,.832,0l2.576,2.576L9.929,4.75a.588.588,0,0,1,.832,0l.832.832a.588.588,0,0,1,0,.832L4.828,13.179A.588.588,0,0,1,4,13.179Z",
    transform: "translate(116.617 411.536)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCheck);
export default __webpack_public_path__ + "static/media/round_check.d361161b829f48b1cfbd0c541cc6456c.svg";
export { ForwardRef as ReactComponent };